// Font assets are installed with npm and served by this application, without build-time Google requests.
import '@fontsource-variable/noto-sans-tc/wght.css';
import '@fontsource-variable/noto-serif-tc/wght.css';
import '@fontsource/fjord-one/latin-400.css';
import styles from './fonts.module.css';

export const notoSansTC = {className: styles.sans};
export const notoSerifTC = {className: styles.serif};
export const fjordOne = {className: styles.numbers};
